export async function pushTag(_t) {
  // GTM functionality removed - function now acts as a no-op
  // This preserves existing function calls without GTM tracking
  return;
}
